import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DateFilterType } from '../constants/filters';
import { UserTicketStatusOption } from '../data/types';
import { useTicketListingsSortAndFilters } from '../hooks/useTicketListingsSortAndFilters';
import { usageTracker } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export function ShowAllRecordsButton({
  screen
}) {
  const {
    setStatusFilter,
    setCreateDateFilter,
    setLastActivityFilter
  } = useTicketListingsSortAndFilters();
  return /*#__PURE__*/_jsx(Button, {
    use: "primary",
    onClick: () => {
      usageTracker.track('Customer Portal App', 'Tickets Discovered', {
        action: 'tickets-show-all',
        screen
      });
      setStatusFilter(UserTicketStatusOption.ALL);
      setCreateDateFilter(DateFilterType.ALL_TIME);
      setLastActivityFilter(DateFilterType.ALL_TIME);
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customer-portal-app.showAllRecords"
    })
  });
}